<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EfaP4E/tc-custom/9780061952364.jpg?1718183633053" alt="This image is the cover for the book Eddie's Bastard"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eddie's Bastard
      </h1>
      <p class="bookDescription body article font2">
        <p>"Eddie's Bastard" is William Amos Mann IV, known as Billy -- the son of a heroic pilot killed in Vietnam and an unknown woman. The last in a line of proud, individualistic Irish-American men, Billy is discovered in a basket at the door of the dilapidated mansion where his bitter, hard-drinking grandfather, Thomas Mann, has exiled himself. Astonished and moved by the arrival of his unexpected progeny, Thomas sets out to raise the boy himself -- on a diet of love, fried baloney, and the fascinating lore of their shared heritage. Listening to his sets out to capture the stories on paper. He is a Mann, Grandpa reminds him daily, and thus destined for greatness. </p><p>Through the tales of his ancestors, his own experiences, and the unforgettable characters who enhance and enliven his adolescence, Billy learns of bravery and cowardice, of life and death, of the heart's capacity for love and for unremitting hatred, eventually grasping the meaning of family and history and their power to shape destiny. Steeped in imagery and threaded with lyricism, <i>Eddie's Bastard</i> is a novel of discovery, of a young man's emergence into the world, and the endless possibilities it offers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Kowalski
      </h2>
      
      <p class="authorDescription body article"><P>William Kowalski is the author of <I>Eddie's Bastard</I>, <I>Somewhere South of Here</I>, and <I>The Adventures of Flash Jackson</I>. He was born in Cleveland, Ohio, in 1970 and raised in Erie, Pennsylvania. He lives in Nova Scotia with his wife and daughter.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b1efa4e